import { render, staticRenderFns } from "./SlowVideoBox.vue?vue&type=template&id=1d5fe71b&scoped=true&"
import script from "./SlowVideoBox.vue?vue&type=script&lang=ts&"
export * from "./SlowVideoBox.vue?vue&type=script&lang=ts&"
import style0 from "./SlowVideoBox.vue?vue&type=style&index=0&id=1d5fe71b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5fe71b",
  null
  
)

export default component.exports